// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Jjuma Pay App Styles */
.bp-card {
  border-radius: 1rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.bp-card-hover {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  animation-duration: 200ms;
}
.bp-card-hover:hover {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.bp-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius);
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.bp-btn-primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(6 95 70 / var(--tw-bg-opacity, 1));
}
.bp-btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius);
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.bp-btn-secondary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bp-btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius);
  background-color: transparent;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.bp-btn-ghost:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.bp-badge-success {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.bp-badge-pending {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.bp-badge-failed {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.bp-badge-neutral {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.bp-input {
  border-radius: var(--radius);
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.bp-input:focus {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity, 1));
}

.hide-scrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yBAAyB;AAEvB;EAAA,mBAA6D;EAA7D,iBAA6D;EAA7D,sBAA6D;EAA7D,4DAA6D;EAA7D,kBAA6D;EAA7D,4DAA6D;EAA7D,0CAA6D;EAA7D,uDAA6D;EAA7D;AAA6D;AAG7D;EAAA,wBAA2E;EAA3E,wDAA2E;EAA3E,0BAA2E;EAA3E;AAA2E;AAA3E;EAAA,sBAA2E;EAA3E,4DAA2E;EAA3E,6EAA2E;EAA3E,iGAA2E;EAA3E;AAA2E;AAG3E;EAAA,oBAA0J;EAA1J,mBAA0J;EAA1J,uBAA0J;EAA1J,4BAA0J;EAA1J,kBAA0J;EAA1J,yDAA0J;EAA1J,kBAA0J;EAA1J,mBAA0J;EAA1J,mBAA0J;EAA1J,sBAA0J;EAA1J,gBAA0J;EAA1J,oBAA0J;EAA1J,mDAA0J;EAA1J,0CAA0J;EAA1J,uDAA0J;EAA1J,uGAA0J;EAA1J,uGAA0J;EAA1J,+FAA0J;EAA1J,8HAA0J;EAA1J,wDAA0J;EAA1J;AAA0J;AAA1J;EAAA,kBAA0J;EAA1J;AAA0J;AAG1J;EAAA,oBAA6K;EAA7K,mBAA6K;EAA7K,uBAA6K;EAA7K,4BAA6K;EAA7K,iBAA6K;EAA7K,sBAA6K;EAA7K,4DAA6K;EAA7K,kBAA6K;EAA7K,4DAA6K;EAA7K,kBAA6K;EAA7K,mBAA6K;EAA7K,mBAA6K;EAA7K,sBAA6K;EAA7K,gBAA6K;EAA7K,oBAA6K;EAA7K,gDAA6K;EAA7K,0CAA6K;EAA7K,uDAA6K;EAA7K,uGAA6K;EAA7K,uGAA6K;EAA7K,+FAA6K;EAA7K,8HAA6K;EAA7K,wDAA6K;EAA7K;AAA6K;AAA7K;EAAA,kBAA6K;EAA7K;AAA6K;AAG7K;EAAA,oBAAuK;EAAvK,mBAAuK;EAAvK,uBAAuK;EAAvK,4BAAuK;EAAvK,6BAAuK;EAAvK,kBAAuK;EAAvK,mBAAuK;EAAvK,mBAAuK;EAAvK,sBAAuK;EAAvK,gBAAuK;EAAvK,oBAAuK;EAAvK,iDAAuK;EAAvK,uGAAuK;EAAvK,+FAAuK;EAAvK,8HAAuK;EAAvK,wDAAuK;EAAvK;AAAuK;AAAvK;EAAA,kBAAuK;EAAvK,4DAAuK;EAAvK,oBAAuK;EAAvK;AAAuK;AAGvK;EAAA,oBAA8G;EAA9G,mBAA8G;EAA9G,qBAA8G;EAA9G,kBAA8G;EAA9G,4DAA8G;EAA9G,sBAA8G;EAA9G,uBAA8G;EAA9G,qBAA8G;EAA9G,wBAA8G;EAA9G,kBAA8G;EAA9G,iBAA8G;EAA9G,gBAA8G;EAA9G,oBAA8G;EAA9G;AAA8G;AAG9G;EAAA,oBAA0G;EAA1G,mBAA0G;EAA1G,qBAA0G;EAA1G,kBAA0G;EAA1G,4DAA0G;EAA1G,sBAA0G;EAA1G,uBAA0G;EAA1G,qBAA0G;EAA1G,wBAA0G;EAA1G,kBAA0G;EAA1G,iBAA0G;EAA1G,gBAA0G;EAA1G,oBAA0G;EAA1G;AAA0G;AAG1G;EAAA,oBAAsG;EAAtG,mBAAsG;EAAtG,qBAAsG;EAAtG,kBAAsG;EAAtG,4DAAsG;EAAtG,sBAAsG;EAAtG,uBAAsG;EAAtG,qBAAsG;EAAtG,wBAAsG;EAAtG,kBAAsG;EAAtG,iBAAsG;EAAtG,gBAAsG;EAAtG,oBAAsG;EAAtG;AAAsG;AAGtG;EAAA,oBAA0G;EAA1G,mBAA0G;EAA1G,qBAA0G;EAA1G,kBAA0G;EAA1G,4DAA0G;EAA1G,sBAA0G;EAA1G,uBAA0G;EAA1G,qBAA0G;EAA1G,wBAA0G;EAA1G,kBAA0G;EAA1G,iBAA0G;EAA1G,gBAA0G;EAA1G,oBAA0G;EAA1G;AAA0G;AAG1G;EAAA,4BAA2I;EAA3I,iBAA2I;EAA3I,sBAA2I;EAA3I,4DAA2I;EAA3I,kBAA2I;EAA3I,4DAA2I;EAA3I,0CAA2I;EAA3I,uDAA2I;EAA3I,uGAA2I;EAA3I,uGAA2I;EAA3I,+FAA2I;EAA3I,8HAA2I;EAA3I,wDAA2I;EAA3I;AAA2I;AAA3I;EAAA,sBAA2I;EAA3I,2DAA2I;EAA3I,2GAA2I;EAA3I,yGAA2I;EAA3I,4FAA2I;EAA3I,oBAA2I;EAA3I;AAA2I;;AAG7I;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Jjuma Pay App Styles */\n.bp-card {\n  @apply bg-white border border-slate-200 shadow-sm rounded-2xl;\n}\n.bp-card-hover {\n  @apply transition-all duration-200 hover:shadow-md hover:border-emerald-200;\n}\n.bp-btn-primary {\n  @apply bg-emerald-700 text-white hover:bg-emerald-800 rounded-lg font-medium px-4 py-2 transition-colors inline-flex items-center justify-center shadow-sm;\n}\n.bp-btn-secondary {\n  @apply bg-white border border-slate-300 text-slate-700 hover:bg-slate-50 rounded-lg font-medium px-4 py-2 transition-colors inline-flex items-center justify-center shadow-sm;\n}\n.bp-btn-ghost {\n  @apply bg-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900 rounded-lg font-medium px-4 py-2 transition-colors inline-flex items-center justify-center;\n}\n.bp-badge-success {\n  @apply inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800;\n}\n.bp-badge-pending {\n  @apply inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800;\n}\n.bp-badge-failed {\n  @apply inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800;\n}\n.bp-badge-neutral {\n  @apply inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800;\n}\n.bp-input {\n  @apply bg-white border border-slate-300 rounded-lg shadow-sm focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition-colors;\n}\n\n.hide-scrollbar {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
